var $ = require('jquery');
require('jquery.cookie');
// var http = 'http://app-loginapi.ycgame.com/ProductApi/api';
var envHost = 'https://productapi.ycgame.com/api';
// var envHost = 'https://productapi-test.ycgame.com:444/api';

var URLS = {
    REG: envHost + '/member',       //注册api
    LOGIN: envHost + '/session',    //登录api
    SMS: envHost + '/sms',          //短信api
    INFO: envHost + '/memberinfo'   //用户信息api
};

var EVENTS = {
    LOGIN: 'auth-login',
    LOGOUT: 'auth-logout',
    REGISTER: 'auth-register'
};

var YC_TOKEN = 'yc_token';


var TokenStorage = function () {

    //IE 不支持 localhost 域名, 开发环境 Cookie 不设置域名
    this.DOMAIN = document.domain.indexOf('.ycgame.com') !== -1 ? '.ycgame.com' : null;
};

TokenStorage.prototype.get = function () {
    return $.cookie(YC_TOKEN);
};
TokenStorage.prototype.set = function (value) {
    $.cookie(YC_TOKEN, value, {expires: 1, path: '/', domain: this.DOMAIN});
};
TokenStorage.prototype.clear = function () {
    $.cookie(YC_TOKEN, '', {expires: -1, path: '/', domain: this.DOMAIN});
};
var ts = new TokenStorage();

function getSourceId() {
    var sources = {
        'bos.ycgame.com': 'wbbos',
        'bosm.ycgame.com': 'wbbos',
        'sy.ycgame.com': 'wbwz',
        // 'bos.ycgame.com': 'wbwz',
        // 'bos.ycgame.com': 'bbsxk',
        // 'bos.ycgame.com': 'wbxk',
    };

    return sources[document.domain] || 'yc';
}

function getTgid() {
    var sources = {
        'bos.ycgame.com': '3',
        'bosm.ycgame.com': '3',
        'sy.ycgame.com': '5',
    };

    return sources[document.domain] || '1';
}

var Auth = function () {
    this._event = $(this);
    this.EVENTS = EVENTS;
    this._src = getSourceId();
    this._tgid = getTgid();
};
Auth.prototype = {
    bind: function () {
        this._event.bind.apply(this._event, arguments);
        return this;
    },
    trigger: function () {
        this._event.trigger.apply(this._event, arguments);
        return this;
    },
    one: function () {
        this._event.one.apply(this._event, arguments);
        return this;
    },

    /**
     * 账户是否存在
     * @param {String} username
     * @param {Object} noCaptcha
     * @returns {jQuery.Deferred}
     */
    exists: function (username, noCaptcha) {
        // var isMobile = /^1\d{10}$/.test(username);
        return doCall('GET', URLS.REG, $.extend({uid: username}, noCaptcha));
    },

    /**
     * 个性注册
     * @param ncResult
     * @param username
     * @param password
     * @param realname
     * @param idcard
     * @returns {*}
     */
    regUsername: function (ncResult, username, password, realname, idcard) {
        ncResult['uid'] = username;
        ncResult['pwd'] = password;
        ncResult['name'] = realname;
        ncResult['nid'] = idcard;
        ncResult['src'] = this._src;
        ncResult['tgid'] = this._tgid;
        ncResult['checkcode'] = 'true';

        return this._reg(ncResult);
    },

    /**
     * 手机注册
     * @param ncResult
     * @param username
     * @param smsCaptcha
     * @param password
     * @param realname
     * @param idcard
     * @returns {*}
     */
    regMobile: function (ncResult, username, smsCaptcha, password, realname, idcard) {

        ncResult['uid'] = username;
        ncResult['vcode'] = smsCaptcha;
        ncResult['pwd'] = password;
        ncResult['name'] = realname;
        ncResult['nid'] = idcard;
        ncResult['src'] = this._src;
        ncResult['tgid'] = this._tgid;
        ncResult['checkcode'] = 'true';
        ncResult['type'] = 'm';

        return this._reg(ncResult);
    },
    _reg: function (data) {
        var self = this;
        var url = this._src === 'wbwz' ? envHost + '/smwz/member' : URLS.REG;
        return doCall('POST', url, data).then(function (rs) {
            ts.set(rs.token);
            self.trigger(EVENTS.REGISTER, ['register']);

            return self.checkLogin();
        });
    },

    /**
     * 发送注册短信
     * @param mobile
     * @param ncResult
     * @returns {jQuery.Deferred}
     */
    sendRegSms: function (mobile, ncResult) {
        ncResult['cmd'] = 'reg';
        ncResult['mobile'] = mobile;

        return doCall('GET', URLS.SMS, ncResult);
    },

    _memberDefer: {},

    /**
     * 登录验证
     * @returns {Promise}
     */
    checkLogin: function (resend) {
        var self = this;
        var defer;

        if (!ts.get()) {
            defer = $.Deferred();
            defer.reject();

            return defer;
        }

        if (resend || (!self._memberDefer.defer) || self._memberDefer.token !== ts.get()) {
            self._memberDefer = {
                token: ts.get(),
                defer: doCall(
                    'GET',
                    URLS.INFO,
                    {},
                    {token: ts.get()}
                ).fail(function (xhr, msg, rs) {
                    if (rs && rs.ok === 60003) {
                        ts.clear();
                    }
                }).then(function (data) {
                    data.username = data.account;
                    self.member = data;
                    self.trigger(EVENTS.LOGIN, ['check']);
                    return data;
                })
            };
        }

        return self._memberDefer.defer;
    },

    //退出登录(已完成)
    logout: function () {
        var self = this;

        return doCall('DELETE', URLS.LOGIN, {token: ts.get()})
            .always(function () {
                self.trigger(EVENTS.LOGOUT, ['logout']);
                ts.clear();
            });
    },

    /**
     *
     * @param {String} username
     * @param {String} password
     * @param {Object} ncResult
     * @returns {*|PromiseLike<T>|Promise<T>}
     */
    login: function (username, password, ncResult) {
        var self = this;
        ncResult['uid'] = username;
        ncResult['pwd'] = password;
        ncResult['src'] = this._src;

        return doCall('POST', URLS.LOGIN, ncResult).then(function (result) {
            ts.set(result.token);
            return self.checkLogin();
        });
    }
};


/**
 *
 * @param {String} method
 * @param {String} url
 * @param {Object} data
 * @param {Object} headers
 * @returns {jQuery.Deferred}
 */
function doCall(method, url, data, headers) {
    var moreOptions = {};
    if (method !== 'GET') {
        data = JSON.stringify(data);
        moreOptions = {
            contentType: 'application/json'
        };
    }

    return $.ajax($.extend({
        crossDomain: true,
        type: method,
        url: url,
        data: data,
        headers: headers || {},
        xhrFields: {
            withCredentials: true
        }
    }, moreOptions)).then(function (rs, statusText, xhr) {
        return $.Deferred(function (defer) {
            //rs.ok == 22 接口问题
            if (rs.ok === 0) {
                defer.resolve(rs);
            } else {
                defer.reject(xhr, rs.msg, rs);
            }
        });
    }, function (xhr, error, text) {
        return $.Deferred(function (defer) {
            defer.reject(xhr, error + ': ' + text);
        });
    });
}

var auth = new Auth();

$(function () {
    $(document).on('click', '[role=yc-logout-btn]', function (e) {
        e.preventDefault();
        auth.logout();
    });
    auth.bind(auth.EVENTS.LOGIN, function () {
        $(document).find('[role~=yc-login-renderer]').ycTmplRender();
    });
    auth.bind(auth.EVENTS.LOGOUT, function () {
        $(document).find('[role~=yc-login-renderer]').trigger('tmpl-rollback');
    });
});

module.exports = auth;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@ycgame/auth/src/auth.js
// module id = 2
// module chunks = 1